import {useCallback, useEffect, useReducer, useRef} from 'react';
import {
  createInitialLiveOverlay,
  reduceCampaignLiveOverlay,
} from '../domain/campaignLiveOverlay';

/**
 * Handles versioned campaign_live_update socket events.
 */
export default function useCampaignLiveUpdates(activeSessionId) {
  const activeSessionIdRef = useRef(activeSessionId);
  activeSessionIdRef.current = activeSessionId;

  const [liveOverlay, dispatch] = useReducer(
    reduceCampaignLiveOverlay,
    undefined,
    createInitialLiveOverlay,
  );

  const handleLiveUpdate = useCallback((payload) => {
    const event = payload?.event ?? payload;
    const sessionId = payload?.activeSessionId ?? activeSessionIdRef.current;

    if (!event?.version || !event?.agentSessionId || !event?.type) {
      return;
    }
    if (sessionId && event.agentSessionId !== sessionId) {
      return;
    }
    if (event.type === 'operation_progress' && !event.trackingId) {
      return;
    }

    dispatch({event, activeSessionId: sessionId});
  }, []);

  const resetLiveOverlay = useCallback(() => {
    dispatch({type: 'reset'});
  }, []);

  useEffect(() => {
    resetLiveOverlay();
  }, [activeSessionId, resetLiveOverlay]);

  return {
    liveOverlay,
    handleLiveUpdate,
    resetLiveOverlay,
  };
}
